import { useGetIdentity } from '@pankod/refine-core'
import { AdminDashboard } from './admin_dashboard'
import { QUsersDashboard } from './question_users'
import { PaperUsersDashboard } from './paper_users'
import { useUserContext } from 'context/user'
import { EvaluationDashboard } from './evaluation_dashboard'
import SystemDashboard from './system_dashboard'

export const Dashboard = () => {
  const { userRole } = useUserContext()
  return (
    <>
      {userRole === 'admin' ? (
        <AdminDashboard />
      ) : userRole === 'srmanager' ? (
        <AdminDashboard />
      ) : userRole === 'subjectincharge' ? (
        <QUsersDashboard />
      ) : userRole === 'qcreator' ? (
        <QUsersDashboard />
      ) : userRole === 'qreviewer' ? (
        <QUsersDashboard />
      ) : userRole === 'qapprover' ? (
        <QUsersDashboard />
      ) : userRole === 'variantcreator' ? (
        <QUsersDashboard />
      ) : userRole === 'qbincharge' ? (
        <QUsersDashboard />
      ) : userRole === 'paperapprover' ? (
        <PaperUsersDashboard />
      ) : userRole === 'papersetter' ? (
        <PaperUsersDashboard />
      ) : userRole === 'deliverymanager' ? (
        <PaperUsersDashboard />
      ) : userRole === 'productmanager' ? (
        <PaperUsersDashboard />
      ) : userRole === 'evaluators' ? (
        <EvaluationDashboard />
      ) : userRole === 'evaluationincharge' ? (
        <EvaluationDashboard />
      ) : userRole === 'systemsupport' ? (
        <SystemDashboard />
      ) : null}
    </>
  )
}
